import React from "react";
export default function NFTItem(props) {

  return (
    <>
      <div className="py-[1.2rem] px-[2rem] w-auto bg-third">
        <div className="w-full"><img className="pb-[2rem]" src={props.img} alt="nft fannationss" /></div>
        <div className="  ">
          <p className="whitespace-nowrap text-white font-bakbak text-[2rem]  text-center">#{props.id}</p>
          {/* <p className="whitespace-nowrap text-white font-bakbak text-[2rem] text-center">${props.price}</p> */}
        </div>
      </div>
    </>
  )
}